import { mapState } from 'vuex'
import scrollToFirstError from '../scrolltoFirstError'
import api from '../../api/checkout'

export default {
    mixins: [scrollToFirstError],

    props: {
        checkoutData: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            data: {
                ...this.defaultData(),
                ...this.checkoutData.userData,
                ...this.resetData(),
            },

            errors: null
        }
    },

    computed: {
        ...mapState('cart', [
            'shippable'
        ]),
        selectedShippingModeHasPickupPoints() {
            const shippingMode = this.checkoutData.userData.shipping_mode
            const selectedShippingMode = this.checkoutData.shippingModes.find(el => el.id === shippingMode)
            return selectedShippingMode && selectedShippingMode.pickupPoints && selectedShippingMode.pickupPoints !== null
        }
    },

    watch: {
        checkoutData(value) {
            this.data = {
                ...this.defaultData(),
                ...value.userData,
                ...this.resetData(),
            }
        }
    },

    methods: {
        setPhoneNumber(phoneNumber) {
            this.data['phone_number'] = {
                'country_code': phoneNumber.countryCode,
                'prefix': phoneNumber.prefix,
                'line_number': phoneNumber.lineNumber
            }
        },

        async next() {
            try {
                await api.setGuestCustomerData(this.data)
                this.errors = null
                this.$bus.$emit('customer-data-saved', this.data)
                this.$bus.$emit('checkout-step-next')
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors
                }

                this.$bus.$emit('checkout-error', error)
            }
        },

        defaultData() {
            return {
                'name': '',
                'email': '',
                'phone_number': '',
                'billing_name': '',
                'billing_zip': '',
                'billing_city': '',
                'billing_address': '',
                'vat_number': '',
                'shipping_name': '',
                'shipping_zip': '',
                'shipping_city': '',
                'shipping_address': '',
                'same_as_billing': true,
            }
        },

        resetData() {
            return {
                tac: null
            }
        },
    }
}
